var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBotNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.84304687 -0.00080566 1.68609375 -0.00161133 2.5546875 -0.00244141 C7.71979821 0.04316887 12.70000034 0.45040374 17.8125 1.1875 C17.8125 1.8475 17.8125 2.5075 17.8125 3.1875 C18.905625 3.125625 19.99875 3.06375 21.125 3 C24.8125 3.1875 24.8125 3.1875 26.4375 4.5625 C27.118125 5.366875 27.118125 5.366875 27.8125 6.1875 C29.45613134 6.90909424 31.12300386 7.58101421 32.8125 8.1875 C36.88716343 10.22483172 39.62452621 12.99952621 42.8125 16.1875 C46.12283382 18.97814747 46.12283382 18.97814747 49.8125 21.1875 C50.3075 22.6725 50.3075 22.6725 50.8125 24.1875 C51.8025 25.6725 51.8025 25.6725 52.8125 27.1875 C53.3075 28.6725 53.3075 28.6725 53.8125 30.1875 C54.8025 31.1775 54.8025 31.1775 55.8125 32.1875 C62.75534217 44.33747379 62.68149281 62.02201182 59.375 75.3125 C58.45235856 78.45928676 57.35267077 81.1746798 55.8125 84.0625 C54.73746552 86.13129601 54.73746552 86.13129601 54.375 88.3125 C53.8125 90.1875 53.8125 90.1875 50.8125 92.1875 C50.3175 93.6725 50.3175 93.6725 49.8125 95.1875 C48.94625 95.5896875 48.94625 95.5896875 48.0625 96 C44.31255734 97.97913641 41.705711 101.401078 39.8125 105.1875 C38.3275 105.6825 38.3275 105.6825 36.8125 106.1875 C33.94918979 108.02187587 33.94918979 108.02187587 32 109.6875 C29.29517445 111.54223752 26.98480058 112.28112841 23.8125 113.1875 C22.97847656 113.43628906 22.14445312 113.68507813 21.28515625 113.94140625 C9.78659086 117.13630965 -1.55906311 117.70525875 -13.3828125 116.24609375 C-17.83505308 116.15308037 -20.54136303 117.75674202 -24.1875 120.1875 C-25.1775 120.5175 -26.1675 120.8475 -27.1875 121.1875 C-27.8475 121.8475 -28.5075 122.5075 -29.1875 123.1875 C-30.6725 123.6825 -30.6725 123.6825 -32.1875 124.1875 C-33.1775 125.1775 -33.1775 125.1775 -34.1875 126.1875 C-35.6725 126.6825 -35.6725 126.6825 -37.1875 127.1875 C-38.85683058 127.8474679 -40.5239521 128.51308869 -42.1875 129.1875 C-42.17589844 128.35613525 -42.16429688 127.52477051 -42.15234375 126.66821289 C-42.12797458 123.54177909 -42.13989111 120.4180332 -42.17529297 117.29174805 C-42.18725979 115.29017787 -42.15849798 113.28849657 -42.12890625 111.28710938 C-42.25355391 103.03958923 -43.32621075 98.48671189 -49.27734375 92.62670898 C-51.05511566 90.9869125 -51.05511566 90.9869125 -53.1875 91.1875 C-53.5175 90.1975 -53.8475 89.2075 -54.1875 88.1875 C-55.21002537 85.92333668 -56.14612771 84.23364602 -57.8125 82.375 C-59.74931201 79.29370817 -59.39283697 76.74667409 -59.1875 73.1875 C-59.8475 72.8575 -60.5075 72.5275 -61.1875 72.1875 C-61.59791591 69.78980706 -61.85221768 67.54356329 -62 65.125 C-62.04423096 64.4134375 -62.08846191 63.701875 -62.1340332 62.96875 C-62.46164731 55.09909616 -60.97949231 47.8119201 -59.1875 40.1875 C-58.99671875 39.29289062 -58.8059375 38.39828125 -58.609375 37.4765625 C-57.49418605 32.49418605 -57.49418605 32.49418605 -55.1875 30.1875 C-53.00694422 27.66623238 -51.3553993 25.63872938 -50.1875 22.5 C-48.94319318 19.62254049 -47.92502914 19.51478686 -45.1875 18.1875 C-44.6925 17.341875 -44.1975 16.49625 -43.6875 15.625 C-42.1875 13.1875 -42.1875 13.1875 -40.0625 12.5625 C-39.44375 12.43875 -38.825 12.315 -38.1875 12.1875 C-37.8575 11.1975 -37.5275 10.2075 -37.1875 9.1875 C-33.625 8 -33.625 8 -30.1875 7.1875 C-30.1875 6.5275 -30.1875 5.8675 -30.1875 5.1875 C-29.445 5.06375 -28.7025 4.94 -27.9375 4.8125 C-25.26054839 4.32337075 -25.26054839 4.32337075 -23.296875 3.21875 C-16.14803896 -0.27623651 -7.78334172 0.0071433 0 0 Z ",
    fill: "#F55C01",
    transform: "translate(84.1875,15.8125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.76183864 1.81463766 4.44355494 3.60024261 6.1640625 6.421875 C6.7209375 7.2675 7.2778125 8.113125 7.8515625 8.984375 C9.47870632 13.24594214 9.57361014 17.0821715 9.66015625 21.6171875 C9.89172367 24.54402246 9.89172367 24.54402246 12.15625 26.23046875 C15.2263558 29.58130406 14.7985881 32.96249999 14.8515625 37.359375 C14.89397869 38.95191013 14.93946847 40.54436685 14.98828125 42.13671875 C15.01607666 43.25409424 15.01607666 43.25409424 15.04443359 44.39404297 C15.12115092 46.59215661 15.12115092 46.59215661 15.80859375 49.36328125 C15.92589844 50.04261719 16.04320312 50.72195312 16.1640625 51.421875 C15.5040625 52.081875 14.8440625 52.741875 14.1640625 53.421875 C12.0390625 53.046875 12.0390625 53.046875 10.1640625 52.421875 C9.78187483 50.76572843 9.45011148 49.09730476 9.1640625 47.421875 C9.4940625 47.091875 9.8240625 46.761875 10.1640625 46.421875 C10.39693258 44.74003552 10.57670416 43.0506334 10.7265625 41.359375 C10.81035156 40.44027344 10.89414063 39.52117187 10.98046875 38.57421875 C11.07134766 37.50880859 11.07134766 37.50880859 11.1640625 36.421875 C10.5040625 36.421875 9.8440625 36.421875 9.1640625 36.421875 C9.2259375 37.453125 9.2878125 38.484375 9.3515625 39.546875 C9.14838102 43.74595896 8.40452324 45.90115097 6.1640625 49.421875 C0.74769015 54.33046244 -5.23674829 53.67041736 -12.1484375 53.734375 C-13.18162109 53.76337891 -14.21480469 53.79238281 -15.27929688 53.82226562 C-21.47080895 53.87389465 -25.14869774 53.60197079 -29.8359375 49.421875 C-32.81303805 45.62350533 -33.36989401 42.17551864 -33.8359375 37.421875 C-33.9881256 43.42745833 -33.9881256 43.42745833 -33.2109375 49.359375 C-33.0871875 50.04 -32.9634375 50.720625 -32.8359375 51.421875 C-33.4959375 52.081875 -34.1559375 52.741875 -34.8359375 53.421875 C-36.9609375 53.046875 -36.9609375 53.046875 -38.8359375 52.421875 C-39.21812517 50.76572843 -39.54988852 49.09730476 -39.8359375 47.421875 C-39.3409375 46.926875 -39.3409375 46.926875 -38.8359375 46.421875 C-38.71574937 45.04250229 -38.65650599 43.65767795 -38.625 42.2734375 C-38.59664062 41.43296875 -38.56828125 40.5925 -38.5390625 39.7265625 C-38.48721291 37.94812146 -38.44287276 36.16944474 -38.40625 34.390625 C-38.3753125 33.54757813 -38.344375 32.70453125 -38.3125 31.8359375 C-38.29268066 31.0620166 -38.27286133 30.2880957 -38.25244141 29.49072266 C-37.73622622 26.92659163 -36.89045835 25.99845406 -34.8359375 24.421875 C-34.1759375 24.421875 -33.5159375 24.421875 -32.8359375 24.421875 C-32.89394531 23.57625 -32.95195313 22.730625 -33.01171875 21.859375 C-33.31333102 14.27598082 -33.03202688 9.16205751 -27.8359375 3.421875 C-19.40719806 -5.18338255 -10.26701415 -5.65798303 0 0 Z ",
    fill: "#FDF9F5",
    transform: "translate(95.8359375,46.578125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.29676875 1.17741741 5.26258029 2.36090292 7.875 4.625 C9.58471828 8.23440526 9.91225557 12.0995687 9 16 C4.59632825 20.09076783 0.21044415 19.48011525 -5.5 19.4375 C-6.92505859 19.4674707 -6.92505859 19.4674707 -8.37890625 19.49804688 C-15.25357593 19.49321237 -15.25357593 19.49321237 -18.6484375 17.25 C-20.63542043 13.94219026 -20.33437617 11.90030352 -19.75390625 8.19140625 C-16.77682089 -0.4621942 -7.68992304 -0.6082425 0 0 Z ",
    fill: "#F66009",
    transform: "translate(89,50)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0 11.22 0 17 0 C16 4 16 4 14.375 5.25 C11.04828123 6.30054277 8.47182704 6.36545548 5 6 C2.0625 4.125 2.0625 4.125 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FBF3E8",
    transform: "translate(75,101)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.67 2.31 4.34 4.62 4 7 C10.27 7.33 16.54 7.66 23 8 C22.67 8.66 22.34 9.32 22 10 C18.56265937 10.08703823 15.12560163 10.14040272 11.6875 10.1875 C10.22280273 10.22520508 10.22280273 10.22520508 8.72851562 10.26367188 C7.32182617 10.27817383 7.32182617 10.27817383 5.88671875 10.29296875 C5.02264404 10.3086792 4.15856934 10.32438965 3.26831055 10.34057617 C0.52318226 9.92840806 -0.36151753 9.20373046 -2 7 C-2 6.34 -2 5.68 -2 5 C-1.34 4.67 -0.68 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#F46C20",
    transform: "translate(72,59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.06058594 1.24136719 1.12117188 2.48273438 1.18359375 3.76171875 C1.26803623 5.40365577 1.35268236 7.04558232 1.4375 8.6875 C1.47681641 9.50412109 1.51613281 10.32074219 1.55664062 11.16210938 C1.73359628 14.52426681 1.92490314 17.66361937 2.66015625 20.95703125 C2.77230469 21.63121094 2.88445312 22.30539063 3 23 C2.34 23.66 1.68 24.32 1 25 C-1.125 24.625 -1.125 24.625 -3 24 C-3.33 22.35 -3.66 20.7 -4 19 C-3.01 18.34 -2.02 17.68 -1 17 C-0.61615491 14.06402461 -0.396157 11.31972627 -0.3125 8.375 C-0.26125977 7.17230469 -0.26125977 7.17230469 -0.20898438 5.9453125 C-0.12643122 3.96403682 -0.06154084 1.98203963 0 0 Z ",
    fill: "#F9F2E5",
    transform: "translate(109,75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.67542976 0.28604898 3.34385343 0.61781233 5 1 C5 2.65 5 4.3 5 6 C4.34 6 3.68 6 3 6 C3 7.32 3 8.64 3 10 C2.01 10 1.02 10 0 10 C-2.08207071 5.59090909 -2.08207071 5.59090909 -1.6875 2.75 C-1 1 -1 1 0 0 Z ",
    fill: "#FBF3EA",
    transform: "translate(82,32)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.08153933 1.58246707 2.13943557 3.16616273 2.1875 4.75 C2.22230469 5.63171875 2.25710937 6.5134375 2.29296875 7.421875 C1.94923684 10.44671583 0.99772541 11.75583602 -1 14 C-1.99 13.67 -2.98 13.34 -4 13 C-3.2884375 11.7315625 -3.2884375 11.7315625 -2.5625 10.4375 C-0.94278487 6.87412671 -0.38743857 3.87438575 0 0 Z ",
    fill: "#EF5C0E",
    transform: "translate(105,83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C4.67 2.32 4.34 3.64 4 5 C2.35 4.67 0.7 4.34 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#FAF1E5",
    transform: "translate(91,59)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.67 1.65 4.34 3.3 4 5 C2.68 4.67 1.36 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#FCFAF5",
    transform: "translate(72,59)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2.4140625 3.06640625 2.4140625 3.06640625 2.625 5.5625 C2.69976562 6.38878906 2.77453125 7.21507813 2.8515625 8.06640625 C2.92503906 9.02353516 2.92503906 9.02353516 3 10 C2.01 10 1.02 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#F2560C",
    transform: "translate(61,83)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(128,115)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(45,144)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(50,141)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(55,138)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(60,135)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(106,129)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(124,29)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotNew);
export default __webpack_public_path__ + "static/media/chat-bot-new.92925100a48c84cc9eedcafba49f7cfd.svg";
export { ForwardRef as ReactComponent };